export enum PPTLogoPositionEnum {
    TOP_LEFT = "Top Left",
    TOP_RIGHT = "Top Right",
    BOTTOM_LEFT = "Bottom Left",
    BOTTOM_RIGHT = "Bottom Right",
    CENTER = "Center"
}